import type { BlockVideo } from 'shared-types';

type LocaleData = BlockVideo['locales'][string];

const defaultBlockData = {};

const translatable: LocaleData['translatable'] = {};
const defaultLocaleData: LocaleData = {
  file: null,
  links: null,
  remote_hash: null,
  remote_id: null,
  source: null,
  subtitles: null,
  translatable
};

const localePlaceholders = {
  file: '{{ locales.file }}' as const,
  links: '{{ locales.links }}' as const,
  remote_hash: '{{ locales.remote_hash }}' as const,
  remote_id: '{{ locales.remote_id }}' as const,
  source: '{{ locales.source }}' as const,
  subtitles: '{{ locales.subtitles }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockVideoData: BlockVideo = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockVideo['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
